export default __webpack_public_path__ + "static/media/12.719c2f96.jpg";